import { RemoteGetActivityById } from 'data/usecases';
import { GetActivityByIdUseCaseInterface } from 'domain/usecases';
import { makeApiUrlActivityById } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetActivityById = (): GetActivityByIdUseCaseInterface =>
  new RemoteGetActivityById(makeApiUrlActivityById(), makeAxiosHttpClient());
